import clsx from 'clsx';
import React from 'react';
import type { Placement } from '@floating-ui/react';

import { Tooltip } from '../../Tooltip/Tooltip';
import { Button } from '../BaseButton/Button';

type BaseButtonProps = Omit<
  JSX.IntrinsicElements['button'],
  'color' | 'type'
> & {
  inverted?: boolean;
  hoverIcon?: React.ReactNode;
  extraClassNames?: string;
  type?: 'button' | 'submit';
  tooltipText?: string;
  tooltipPlacement?: Placement;
};

export const TextButton = ({
  onClick,
  children,
  inverted,
  disabled,
  icon,
  hoverIcon,
  extraClassNames,
  type = 'button',
  tooltipText,
  tooltipPlacement = 'top-start',
  ...props
}: BaseButtonProps & { icon?: React.ReactNode }): JSX.Element => (
  <Tooltip
    tooltipComponent={<span className="text-main">{tooltipText}</span>}
    tooltipDisabled={!tooltipText}
    placement={tooltipPlacement}
    baseComponent={
      <Button
        {...props}
        onClick={onClick}
        type={type}
        disabled={disabled}
        cursor={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
        color={
          inverted
            ? 'text-main hover:text-main-500'
            : 'text-main-500 hover:text-main'
        }
        extraClassNames={clsx(
          'group flex flex-row items-center outline-none',
          extraClassNames
        )}
      >
        <div className="flex w-full items-center">
          {hoverIcon ? (
            <>
              <span className="block group-hover:hidden">{icon}</span>
              <span className="hidden group-hover:block">{hoverIcon}</span>
            </>
          ) : (
            icon
          )}
          {children}
        </div>
      </Button>
    }
  />
);
